module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.loadMore),
      expression: "loadMore"
    }]
  }, [_c('loader', {
    attrs: {
      "loading": _vm.loading
    }
  }), _vm._v(" "), (!_vm.loading) ? _c('div', [(_vm.listTitle) ? _c('page-title', {
    attrs: {
      "image": _vm.listLogo,
      "title": _vm.listTitle
    }
  }, [_c('template', {
    slot: "header-right"
  }, [_vm._t("header-actions")], 2)], 2) : _vm._e(), _vm._v(" "), (_vm.$slots['filters']) ? _c('panel', {
    attrs: {
      "title": _vm.filterTitle
    }
  }, [_c('span', {
    staticClass: "badge badge--default",
    attrs: {
      "slot": "header-right"
    },
    slot: "header-right"
  }, [_vm._v(_vm._s(_vm.$tc('items.found.label', _vm.total, {
    count: _vm.total
  })))]), _vm._v(" "), _c('form', {
    attrs: {
      "id": "list-search"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSearch.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "l-row"
  }, [_vm._t("filters")], 2), _vm._v(" "), _c('div', {
    staticClass: "u-textRight"
  }, [_c('button', {
    staticClass: "btn",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.clearFilters
    }
  }, [_vm._v("\n            Limpar filtros\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn--success",
    class: {
      'is-loading': _vm.loading
    },
    attrs: {
      "disabled": _vm.loading,
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "icon-search size"
  }), _vm._v(" \n            Pesquisar\n          ")])])])]) : _vm._e(), _vm._v(" "), (_vm.$slots['top-actions-left'] || _vm.$slots['top-actions-right']) ? _c('div', {
    staticClass: "actions"
  }, [(_vm.$slots['top-actions-left']) ? _c('div', {
    staticClass: "l-row left"
  }, [_vm._t("top-actions-left")], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "l-row right"
  }, [_vm._t("top-actions-right")], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "l-row vertical-flex"
  }, [_vm._t("default"), _vm._v(" "), _c('loader', {
    attrs: {
      "loading": _vm.options.fetchingMore,
      "overlay": false
    }
  })], 2), _vm._v(" "), (!_vm.options.fetchingMore && !_vm.hasNext) ? _c('div', {
    staticClass: "no-more u-textCenter"
  }, [_vm._v("Não existem mais registros")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "l-row"
  }, [_vm._t("bottom-actions")], 2)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-800e7f14","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/list/Scroll.vue
// module id = 3338
// module chunks = 0